import { Environment } from '@lendi/lala-utils';
import { LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID, LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID, LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID, LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID, } from '../../constants';
export var getClientId = function (environment) {
    switch (environment) {
        case Environment.Development:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
        case Environment.Staging:
            return LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID;
        case Environment.Preproduction:
            return LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID;
        case Environment.Production:
            return LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID;
        default:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
    }
};
//# sourceMappingURL=index.js.map